module.exports = __webpack_public_path__ + "static/kasuien04-f592d39564d113e8ca63e7f1f6fa4a8e.jpg";